// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

const baseURL = window.API_URL || 'https://fp-dev3.fkcore.org/api/v2'

export const getExchangeRate = createAsyncThunk('common/getExchangeRate', async params => {
  const response = await axios.get(`${baseURL}/exchange-providers`, { params })
  return { params, data: response.data }
})

export const commonSlice = createSlice({
  name: 'common',
  initialState: {
    data: undefined
  },
  reducers: {},
  extraReducers: builder => {
    builder
        .addCase(getExchangeRate.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
  }
})

export default commonSlice.reducer
